import ReactDOM from "react-dom/client";
import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

/* Styling */
import "./index.css";
import "./assets/fonts/Aeonik-Regular.ttf";

/* Wrapper view */
import App from "./App";

/* Pages */
import Home from "./views/Home";
import WPAppen from "./views/catalogue/WPAppen";
import WPTech from "./views/catalogue/WPTech";
import Twiceme from "./views/catalogue/Twiceme";
import Timelog from "./views/catalogue/Timelog";
import Stormer from "./views/catalogue/Stormer";
import Provento from "./views/catalogue/Provento";
import AlrikDrive from "./views/catalogue/AlrikDrive";
import AlrikCockpit from "./views/catalogue/AlrikCockpit";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <App>
        <Home />
      </App>
    ),
  },
  {
    path: "/provento",
    element: (
      <App>
        <Provento />
      </App>
    ),
  },
  {
    path: "/wp_appen",
    element: (
      <App>
        <WPAppen />
      </App>
    ),
  },
  {
    path: "/wp_tech",
    element: (
      <App>
        <WPTech />
      </App>
    ),
  },
  {
    path: "/twiceme",
    element: (
      <App>
        <Twiceme />
      </App>
    ),
  },
  {
    path: "/time_log",
    element: (
      <App>
        <Timelog />
      </App>
    ),
  },
  {
    path: "/stormer",
    element: (
      <App>
        <Stormer />
      </App>
    ),
  },
  {
    path: "/alrik-drive",
    element: (
      <App>
        <AlrikDrive />
      </App>
    ),
  },
  {
    path: "/alrik-cockpit",
    element: (
      <App>
        <AlrikCockpit />
      </App>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
